module.exports = fox._r("fonts/mc_icons-webfont.eot", __webpack_public_path__ + "_/_/_/affiliate/fonts/PY1Iudj.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/fonts/mc_icons-webfont.eot
// module id = 398
// module chunks = 4